/**
 * utils.js collects helper functions we can use in our scripts
 */

import { formatDefaultLocale } from 'd3-format';
import $ from 'jquery';

const germanNumberFormat = formatDefaultLocale({
  decimal: ',',
  thousands: '.',
  grouping: [3],
  currency: ['€', '']
});

export function isUndefined(obj) {
  return typeof obj === 'undefined';
}

export function isDefined(obj) {
  return !(isUndefined(obj));
}

export function isIframe() {
  return top !== parent || window != window.top;
}

export function isNumeric(number) {
  if (isUndefined(number)){
    return false;
  }
  return !isNaN(number) && isFinite(number);
}

export function numberFormat(num, decimals = 0) {
  if (typeof num === 'undefined') {
    return '';
  }

  return germanNumberFormat.format(`,.${decimals}f`)(num);
}

export function sortByKey(key, isAsc) {
  if (isUndefined(isAsc)) {
    isAsc = true;
  }

  return (a, b) => {
    if (a[key] < b[key]) {
      return isAsc ? 1 : -1;
    } else if (a[key] > b[key]) {
      return isAsc ? -1 : 1;
    } else {
      return 0;
    }
  }
}

export function arraysEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length != b.length) return false;

  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

export function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export function slugify(str) {
  return str.toLowerCase()
    .replace(/\.|\,/g, '')
    .replace(/\s/g, '-')
    .replace(/ü/g, 'ue')
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe');
}

// you can use this function if you want an element
// to trigger click only on click and not on swipe
export function clickOnly(el) {
  let hasMoved;

  $(el).on('touchend touchstart touchmove', function(e) {
    if(e.type === 'touchstart') {
      hasMoved = false;
    }
    else if(e.type === 'touchmove') {
      hasMoved = true;
    }
    else if(e.type === 'touchend') {
      if(!hasMoved) {
        e.stopPropagation();
        e.preventDefault();
        $(e.target).trigger('click');
      }
    }
  });
}

/**
 * Counts up/down a number
 * @elm {DOM node} where we render the number
 * @opts {Object} defaults are start=0, end=0 and duration=1000
 */
export function counter(elm, opts) {
  const start = opts.start || 0;
  const end = opts.end || 0;
  const duration = opts.duration || 1000;
  const timeoutDuration = duration / Math.abs(end - start);
  const isIncreasing = end > start;

  count(start);

  function count(num) {
    if ((isIncreasing && num > end) || (!isIncreasing && num < end)) {
      return false;
    }

    elm.innerHTML = num;
    setTimeout(() => isIncreasing ? count(++num) : count(--num), timeoutDuration);
  }
}

/**
 * Creates a lookup object
 * @data {Array} input data
 * @key {String} name of the key we want to group by
 * @return {Object} Lookup object
 */
export function groupBy(data, key) {
  return data.reduce((prev, curr) => {
    prev[curr[key]] = typeof prev[curr[key]] === 'undefined' ? [] : prev[curr[key]];
    prev[curr[key]].push(curr);

    return prev;
  }, {});
}

///////////////////////
/// device detection //
///////////////////////

function checkPointerEvents() {
  const element = document.createElement('div');
	element.style.cssText = 'pointer-events:auto';
	return element.style.pointerEvents === 'auto';
}

export const isOldBrowser = !(('querySelector' in document) && ('localStorage' in window) && ('addEventListener' in window));
export const isMobile = !isUndefined(window.orientation);
export const isSmartphone = /android.*mobile|mobile.*android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
export const clickEvent = isMobile ? 'touchstart' : 'click';
export const hasPointerEvents = checkPointerEvents();
export const isIE = detectIE();
export const isTouch = 'ontouchstart' in window;

function detectIE() {
  const ua = window.navigator.userAgent;
  return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0;
}

//////////////////
/// geo helpers //
//////////////////

export const geo = {
	berlinCenter : [52.52, 13.4],
	berlinBounds : [[52, 12], [53, 15]],

  getZoomByWindowSize: () => {
    let mapZoom = 11;

    if (smartphone || window.innerWidth < 500) {
      mapZoom = 10;
    } else if (window.innerWidth < 768) {
      mapZoom = 10;
    } else if (window.innerWidth < 1100) {
      mapZoom = 11;
    } else if (window.innerWidth > 2000) {
      mapZoom = 11;
    }

    return mapZoom;
  }
}

export function trackEvent(name, data, classname) {
  dataLayer.push({
    'event': 'interaktiv_event',
    'name': `interaktiv_${name}`,
    'class': classname,
    'event_data': data
  });
}

export function animateHeadline() {
  $('.intro').addClass('is-animated-headline');
}

export function forEachEl(elements, callback) {
  return [].forEach.call(elements, callback);
}

export function noop() {

}

export default {
	isUndefined,
  isDefined,
	isNumeric,
	numberFormat,
  debounce,
  arraysEqual,
  clickOnly,
  sortByKey,
  slugify,
  counter,
  groupBy,

	isOldBrowser,
	isMobile,
	isSmartphone,
  clickEvent,
  hasPointerEvents,
  isIE,
  isIframe,
  isTouch,

	geo,
  trackEvent,

  animateHeadline,
  forEachEl,
  noop
};
